"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJSBridgeInstance = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var __1 = require("..");
/**
 *
 * @deprecated **不鼓励直接使用**
 */
function useJSBridgeInstance() {
    var context = React.useContext(__1.JSBridgeContext);
    if (!context)
        throw new Error('JSBridgeProvider never found.');
    return context;
}
exports.useJSBridgeInstance = useJSBridgeInstance;
//# sourceMappingURL=useJSBridgeInstance.js.map